import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Divider, Grid, Hidden, Typography } from "@material-ui/core";
import fontConfig from "../../constants/fonts";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      backgroundColor: "white",
    },
  },
  icon: {
    height: "30vh",
  },
  gridContainer: {
    // backgroundColor: "red",
    height: "100%",
    // padding: "3vh",
  },
  title: {
    ...fontConfig.bold,
    fontSize: "2.5rem",
    color: theme.palette.primary.main,
    // fontFamily: ,
    textTransform: "uppercase",
    letterSpacing: "0.1rem",
    // backgroundColor: theme.palette.primary.main,
    borderRadius: 100,
    // boxShadow: "5px 5px 20px rgba(0,0,0,0.2)",
    // width: "20%",
    // width: "15%",
    textAlign: "center",
    padding: "20px 20px 5px 20px",
    [theme.breakpoints.down("md")]: {
      padding: "20px 10px 5px 10px",
      fontSize: "1.5rem",
      letterSpacing: "0.05rem",
    },
  },
  divider: {
    backgroundColor: theme.palette.secondary.main,
    height: theme.spacing(0.5),
    borderRadius: 100,
    [theme.breakpoints.down("md")]: {
      height: theme.spacing(0.2),
      marginTop: theme.spacing(1),
    },
  },
}));

const TitleContainer = (props) => {
  const classes = useStyles();

  return (
    <Grid
      container
      // direction="column"
      justify="space-evenly"
      alignItems="center"
      className={classes.gridContainer}
    >
      <Hidden mdDown>
        <Grid item>
          <img src={props.icon} alt={props.icon} className={classes.icon} />
        </Grid>
      </Hidden>

      <Grid item sm={12} xs={12}>
        <Typography variant="h4" align="center" className={classes.title}>
          {props.title}
        </Typography>
      </Grid>
      <Hidden smUp>
        <Grid item sm={4} md={4} xs={4} lg={4}>
          <Divider className={classes.divider} />
        </Grid>
      </Hidden>
    </Grid>
  );
};
export default TitleContainer;
